// // // src/pages/CategoryServices.jsx
// // import React, { useEffect, useMemo, useState } from "react";
// // import { useNavigate, useParams } from "react-router-dom";
// // import {
// //     subscribeCategories,
// //     subscribeSubcategories,
// //     subscribeServiceItems,
// //     createBooking, // NEW
// // } from "../lib/servicesApi";
// // import "../styles/theme.css";
// // import { auth } from "../firebase"; // ✅ add this line

// // /** Decode minimal HTML entities for display */
// // const decodeEntities = (str) =>
// //     String(str || "")
// //         .replace(/&amp;/g, "&")
// //         .replace(/&lt;/g, "<")
// //         .replace(/&gt;/g, ">")
// //         .replace(/&quot;/g, '"')
// //         .replace(/&#039;/g, "'");

// // /** Slugify used both in ServicesSection and here to resolve catSlug */
// // const slugify = (s) =>
// //     decodeEntities(String(s || ""))
// //         .toLowerCase()
// //         .trim()
// //         .replace(/['"]/g, "")
// //         .replace(/&/g, "and")
// //         .replace(/[^a-z0-9]+/g, "-")
// //         .replace(/^-+|-+$/g, "");

// // const CategoryServices = () => {
// //     const { catSlug } = useParams();
// //     const navigate = useNavigate?.();

// //     // Data state
// //     const [cats, setCats] = useState([]);
// //     const [catError, setCatError] = useState(null);
// //     const [catsLoading, setCatsLoading] = useState(true);

// //     const [subcats, setSubcats] = useState([]);
// //     const [subcatError, setSubcatError] = useState(null);
// //     const [subcatsLoading, setSubcatsLoading] = useState(true);

// //     const [list, setList] = useState([]);
// //     const [svcError, setSvcError] = useState(null);
// //     const [svcLoading, setSvcLoading] = useState(true);

// //     // Filters
// //     const [activeSubcat, setActiveSubcat] = useState("all");

// //     const [selected, setSelected] = useState(null);
// //     const [submitting, setSubmitting] = useState(false);

// //     const openBooking = (svc) => setSelected(svc);
// //     const closeBooking = () => setSelected(null);

// //     // const handleSubmit = async (e) => {
// //     //     e.preventDefault();
// //     //     if (!selected) return;
// //     //     try {

// //     //         if (!auth?.currentUser) {
// //     //             alert("Please sign in to book a service.");
// //     //             return;
// //     //         }



// //     //         setSubmitting(true);
// //     //         const fd = new FormData(e.currentTarget);

// //     //         // Extract universal scheduling fields
// //     //         const date = fd.get("date") || null;
// //     //         const time = fd.get("time") || null;
// //     //         const address = fd.get("address") || null;
// //     //         // const mobile = fd.get("mobile") || null;
// //     //         const notes = fd.get("notes") || null;

// //     //         let mobileRaw = fd.get("mobile") || "";
// //     //         const mobile = mobileRaw.replace(/\D/g, ""); // keep digits only

// //     //         // Option A: simple 10 digits
// //     //         // const isValidMobile = /^[0-9]{10}$/.test(mobile);

// //     //         // Option B (recommended for India): start with 6-9 and 10 digits
// //     //         const isValidMobile = /^[6-9]\d{9}$/.test(mobile);

// //     //         if (!isValidMobile) {
// //     //             alert("Please enter a valid 10-digit mobile number (starts with 6-9).");
// //     //             return;
// //     //         }




// //     //         // Collect dynamic form fields:
// //     //         // Anything present in selected.formFields (excluding the universal ones)
// //     //         const formFields = Array.isArray(selected.formFields) ? selected.formFields : [];
// //     //         const formData = {};

// //     //         formFields.forEach((f) => {
// //     //             const name = f?.name;
// //     //             if (!name) return;

// //     //             // Checkbox needs special handling → presence means "on"
// //     //             if (f.type === "checkbox") {
// //     //                 formData[name] = fd.get(name) ? true : false;
// //     //             } else {
// //     //                 formData[name] = fd.get(name) ?? "";
// //     //             }
// //     //         });

// //     //         const bookingPayload = { date, time, address, mobile, notes, formData };

// //     //         // Write booking (and mirror under the service doc)
// //     //         await createBooking(selected, bookingPayload, { mirrorUnderServiceDoc: false });

// //     //         closeBooking();
// //     //         alert(`Booking submitted for "${selected.name ?? selected.title}". We’ll reach out soon!`);
// //     //     } catch (err) {
// //     //         // console.error("Booking submit failed:", err);
// //     //         // alert("Failed to submit booking. Please try again.");

// //     //         console.error("Booking submit failed:", err);
// //     //         const code = err?.code || "unknown";
// //     //         const msg = err?.message || "Failed to submit booking.";
// //     //         alert(`${msg}\n(${code})`);

// //     //     } finally {
// //     //         setSubmitting(false);
// //     //     }
// //     // };

// //     // Selected category key/label resolved from catSlug

// //     const handleSubmit = async (e) => {
// //         e.preventDefault();
// //         if (!selected) return;

// //         try {
// //             if (!auth?.currentUser) {
// //                 alert("Please sign in to book a service.");
// //                 return;
// //             }

// //             setSubmitting(true);
// //             const fd = new FormData(e.currentTarget);

// //             const date = fd.get("date") || null;
// //             const time = fd.get("time") || null;
// //             const address = (fd.get("address") || "").trim() || null;
// //             const notes = (fd.get("notes") || "").trim() || null;

// //             // Sanitize and validate mobile
// //             let mobileRaw = fd.get("mobile") || "";
// //             const mobile = mobileRaw.replace(/\D/g, "");
// //             const isValidMobile = /^[6-9]\d{9}$/.test(mobile); // or /^[0-9]{10}$/
// //             if (!isValidMobile) {
// //                 alert("Please enter a valid 10-digit mobile number (starts with 6-9).");
// //                 return; // finally will still run and reset submitting
// //             }

// //             const RESERVED_NAMES = new Set(["date", "time", "address", "mobile", "notes"]);
// //             const formFields = Array.isArray(selected.formFields) ? selected.formFields : [];
// //             const formData = {};

// //             formFields.forEach((f) => {
// //                 const name = f?.name;
// //                 if (!name || RESERVED_NAMES.has(name)) return;

// //                 if (f.type === "checkbox") {
// //                     formData[name] = fd.get(name) ? true : false;
// //                 } else {
// //                     formData[name] = (fd.get(name) ?? "").toString().trim();
// //                 }
// //             });

// //             const bookingPayload = { date, time, address, mobile, notes, formData };

// //             await createBooking(selected, bookingPayload, { mirrorUnderServiceDoc: false });

// //             closeBooking();
// //             alert(`Booking submitted for "${selected.name ?? selected.title}". We’ll reach out soon!`);
// //         } catch (err) {
// //             console.error("Booking submit failed:", err);
// //             const code = err?.code || "unknown";
// //             const msg = err?.message || "Failed to submit booking.";
// //             alert(`${msg}\n(${code})`);
// //         } finally {
// //             setSubmitting(false);
// //         }
// //     };


// //     const resolved = useMemo(() => {
// //         if (!cats?.length || !catSlug) return null;
// //         const match = cats.find((c) => {
// //             const s1 = slugify(c.label || c.key);
// //             const s2 = slugify(c.key || c.label);
// //             return s1 === catSlug || s2 === catSlug;
// //         });
// //         if (!match) return null;
// //         return {
// //             key: match.key,
// //             label: decodeEntities(match.label || match.key),
// //         };
// //     }, [cats, catSlug]);

// //     // Subscribe to categories
// //     useEffect(() => {
// //         setCatsLoading(true);
// //         const unsub = subscribeCategories(
// //             (items) => {
// //                 setCats(items || []);
// //                 setCatsLoading(false);
// //             },
// //             (err) => {
// //                 setCatError(err);
// //                 setCatsLoading(false);
// //             }
// //         );
// //         return () => unsub && unsub();
// //     }, []);

// //     // Subscribe subcategories for this category
// //     useEffect(() => {
// //         if (!resolved?.key) {
// //             setSubcats([]);
// //             setSubcatsLoading(false);
// //             return;
// //         }
// //         setSubcatsLoading(true);
// //         const unsub = subscribeSubcategories(
// //             (items) => {
// //                 const filtered = (items || []).filter((s) => s.categoryKey === resolved.key);
// //                 setSubcats(filtered);
// //                 setSubcatsLoading(false);
// //             },
// //             (err) => {
// //                 setSubcatError(err);
// //                 setSubcatsLoading(false);
// //             },
// //             { categoryKey: resolved.key }
// //         );
// //         return () => unsub && unsub();
// //     }, [resolved?.key]);

// //     // Subscribe services with filters
// //     useEffect(() => {
// //         if (!resolved?.key) {
// //             setList([]);
// //             setSvcLoading(false);
// //             return;
// //         }
// //         setSvcLoading(true);
// //         const unsub = subscribeServiceItems(
// //             (items) => {
// //                 setList(items || []);
// //                 setSvcLoading(false);
// //             },
// //             (err) => {
// //                 setSvcError(err);
// //                 setSvcLoading(false);
// //             },
// //             {
// //                 category: resolved.key,
// //                 subcategory: activeSubcat === "all" ? undefined : activeSubcat,
// //             }
// //         );
// //         return () => unsub();
// //     }, [resolved?.key, activeSubcat]);

// //     // Build subcategory chips
// //     const subcatChips = useMemo(() => {
// //         const chips = [{ key: "all", label: "All" }];
// //         const active = (subcats || []).filter((s) => s.active);
// //         active.forEach((s) => chips.push({ key: s.key, label: decodeEntities(s.label || s.key) }));
// //         return chips;
// //     }, [subcats]);

// //     // Visible services
// //     const services = useMemo(() => {
// //         const activeOnly = (list || []).filter((s) => !!s.isActive);
// //         return resolved?.key ? activeOnly.filter((s) => s.category === resolved.key) : activeOnly;
// //     }, [list, resolved?.key]);

// //     const goBack = () => {
// //         try {
// //             if (navigate) {
// //                 navigate(-1);
// //                 return;
// //             }
// //         } catch { }
// //         if (window.history.length > 1) window.history.back();
// //         else window.location.href = "/";
// //     };

// //     const titleText = resolved?.label || "Services";

// //     /** Render a single dynamic field based on service.formFields definition */
// //     const renderField = (f) => {
// //         if (!f?.name) return null;
// //         const id = `dyn_${f.name}`;
// //         const required = !!f.required;
// //         const label = f.label || f.name;

// //         switch (f.type) {
// //             case "text":
// //             case "email":
// //             case "tel":
// //             case "number":
// //                 return (
// //                     <div className="col-12">
// //                         <label className="form-label" htmlFor={id}>{label}</label>
// //                         <input
// //                             id={id}
// //                             name={f.name}
// //                             type={f.type}
// //                             className="form-control"
// //                             required={required}
// //                             inputMode={f.type === "tel" ? "tel" : undefined}
// //                         />
// //                     </div>
// //                 );
// //             case "textarea":
// //                 return (
// //                     <div className="col-12">
// //                         <label className="form-label" htmlFor={id}>{label}</label>
// //                         <textarea id={id} name={f.name} className="form-control" rows={3} required={required}></textarea>
// //                     </div>
// //                 );
// //             case "select":
// //                 return (
// //                     <div className="col-12">
// //                         <label className="form-label" htmlFor={id}>{label}</label>
// //                         <select id={id} name={f.name} className="form-select" required={required}>
// //                             <option value="">Select…</option>
// //                             {(f.options || []).map((opt) => (
// //                                 <option key={String(opt)} value={opt}>{opt}</option>
// //                             ))}
// //                         </select>
// //                     </div>
// //                 );
// //             case "radio":
// //                 return (
// //                     <div className="col-12">
// //                         <div className="form-label">{label}</div>
// //                         <div className="d-flex flex-wrap gap-3">
// //                             {(f.options || []).map((opt, idx) => {
// //                                 const oid = `${id}_${idx}`;
// //                                 return (
// //                                     <div className="form-check" key={oid}>
// //                                         <input
// //                                             className="form-check-input"
// //                                             type="radio"
// //                                             name={f.name}
// //                                             id={oid}
// //                                             value={opt}
// //                                             required={required}
// //                                         />
// //                                         <label className="form-check-label" htmlFor={oid}>{opt}</label>
// //                                     </div>
// //                                 );
// //                             })}
// //                         </div>
// //                     </div>
// //                 );
// //             case "checkbox":
// //                 return (
// //                     <div className="col-12">
// //                         <div className="form-check">
// //                             <input className="form-check-input" type="checkbox" id={id} name={f.name} />
// //                             <label className="form-check-label" htmlFor={id}>{label}</label>
// //                         </div>
// //                     </div>
// //                 );
// //             default:
// //                 return (
// //                     <div className="col-12">
// //                         <label className="form-label" htmlFor={id}>{label}</label>
// //                         <input id={id} name={f.name} className="form-control" required={required} />
// //                     </div>
// //                 );
// //         }
// //     };

// //     return (
// //         <section className="py-5 bg-light">
// //             <div className="container">
// //                 {/* Sticky header with back */}
// //                 <div
// //                     className="d-flex align-items-center justify-content-between mb-3"
// //                     style={{
// //                         position: "sticky",
// //                         top: 0,
// //                         zIndex: 10,
// //                         background: "var(--bs-light, #f8f9fa)",
// //                         padding: "8px 0",
// //                     }}
// //                 >
// //                     <button type="button" className="btn btn-outline-secondary" onClick={goBack}>
// //                         <i className="bi bi-arrow-left me-1" aria-hidden="true"></i>
// //                         Back
// //                     </button>
// //                     <span className="text-muted small">
// //                         Viewing: <strong>{titleText}</strong>
// //                     </span>
// //                 </div>

// //                 {/* Heading */}
// //                 <header className="mb-4 text-center">
// //                     <h2 className="fw-bold">{titleText}</h2>
// //                     <p className="text-muted mb-2">Browse services and filter by subcategory.</p>
// //                 </header>

// //                 {/* Subcategory filter chips */}
// //                 <div className="d-flex flex-wrap justify-content-center gap-2 mb-3">
// //                     {subcatChips.map((chip) => (
// //                         <button
// //                             key={chip.key}
// //                             type="button"
// //                             className={`btn btn-sm ${activeSubcat === chip.key ? "btn-primary-navbar-reg" : "btn-outline-teal"}`}
// //                             onClick={() => setActiveSubcat(chip.key)}
// //                             aria-pressed={activeSubcat === chip.key}
// //                         >
// //                             {chip.label}
// //                         </button>
// //                     ))}
// //                 </div>

// //                 {/* Errors */}
// //                 {catError && <div className="alert alert-danger">Categories error: {catError.message}</div>}
// //                 {subcatError && <div className="alert alert-danger">Subcategories error: {subcatError.message}</div>}
// //                 {svcError && <div className="alert alert-danger">Services error: {svcError.message}</div>}

// //                 {/* Loading */}
// //                 {(catsLoading || subcatsLoading || svcLoading) && (
// //                     <div className="text-center my-4">
// //                         <div className="spinner-border text-primary" role="status" aria-hidden="true" />
// //                         <div className="mt-2 text-muted small">Loading…</div>
// //                     </div>
// //                 )}

// //                 {/* Services grid */}
// //                 <div className="row g-3">
// //                     {services.map((svc) => {
// //                         const title = svc.name ?? svc.title ?? "Untitled service";
// //                         const desc = svc.description ?? svc.desc ?? "";
// //                         const icon = svc.icon ?? "bi-tools";
// //                         const price = typeof svc.price === "number" ? svc.price : Number(svc.price) || 0;

// //                         return (
// //                             <div key={svc.id} className="col-12 col-sm-6 col-lg-4">
// //                                 <article className="card h-100 shadow-sm">
// //                                     <div className="card-body d-flex flex-column">
// //                                         <div className="d-flex align-items-center mb-2">
// //                                             <span className="rounded-3 p-2 me-2" style={{ background: "#EEF2FF" }}>
// //                                                 <i className={`bi ${icon} text-primary-label fs-5`} aria-hidden="true"></i>
// //                                             </span>
// //                                             <h5 className="card-title mb-0">{title}</h5>
// //                                         </div>
// //                                         <p className="text-muted mb-2 flex-grow-1">{desc}</p>
// //                                         <div className="d-flex align-items-center justify-content-between">
// //                                             <span className="text-secondary">Starting at ₹{price}</span>
// //                                             <button
// //                                                 type="button"
// //                                                 className="btn btn-outline-teal btn-sm"
// //                                                 onClick={() => openBooking({ ...svc, title, desc, icon, price })}
// //                                                 aria-label={`Book ${title}`}
// //                                             >
// //                                                 Book Service
// //                                             </button>
// //                                         </div>
// //                                     </div>
// //                                 </article>
// //                             </div>
// //                         );
// //                     })}

// //                     {!svcLoading && services.length === 0 && !svcError && (
// //                         <div className="col-12">
// //                             <div className="alert alert-info">No services available for this subcategory yet.</div>
// //                         </div>
// //                     )}

// //                     {/* Booking Modal (controlled) */}
// //                     <div
// //                         className={`modal fade ${selected ? "show d-block" : ""}`}
// //                         tabIndex={-1}
// //                         role="dialog"
// //                         aria-modal={selected ? "true" : "false"}
// //                         aria-hidden={selected ? "false" : "true"}
// //                     >
// //                         <div className="modal-dialog modal-dialog-centered">
// //                             <div className="modal-content">
// //                                 <div className="modal-header primary-bg ">
// //                                     <h5 className="modal-title">
// //                                         {selected ? `Book: ${selected.title}` : "Book Service"}
// //                                     </h5>
// //                                     <button
// //                                         type="button"
// //                                         className="btn-close"
// //                                         aria-label="Close"
// //                                         onClick={closeBooking}
// //                                         disabled={submitting}
// //                                     />
// //                                 </div>
// //                                 <div className="modal-body">
// //                                     {selected && (
// //                                         <form onSubmit={handleSubmit}>
// //                                             <div className="mb-3 d-flex align-items-center">
// //                                                 <span className="rounded-3 p-2 me-2" style={{ background: "#EEF2FF" }}>
// //                                                     <i className={`bi ${selected.icon} text-primary-label fs-5`} aria-hidden="true"></i>
// //                                                 </span>
// //                                                 <div>
// //                                                     <div className="fw-semibold">{selected.title}</div>
// //                                                     <small className="text-muted">Starting at ₹{selected.price}</small>
// //                                                 </div>
// //                                             </div>

// //                                             <div className="row g-3">
// //                                                 {/* --- DYNAMIC SERVICE-SPECIFIC FIELDS --- */}
// //                                                 {(Array.isArray(selected.formFields) ? selected.formFields : []).map((f, idx) => (
// //                                                     <React.Fragment key={`${f.name}_${idx}`}>
// //                                                         {renderField(f)}
// //                                                     </React.Fragment>
// //                                                 ))}

// //                                                 {/* --- UNIVERSAL SCHEDULING/ADDRESS FIELDS --- */}
// //                                                 <div className="col-12 col-md-6">
// //                                                     <label className="form-label" htmlFor="date">Date</label>
// //                                                     <input type="date" id="date" name="date" className="form-control" required />
// //                                                 </div>
// //                                                 <div className="col-12 col-md-6">
// //                                                     <label className="form-label" htmlFor="time">Time</label>
// //                                                     <input type="time" id="time" name="time" className="form-control" required />
// //                                                 </div>
// //                                                 <div className="col-12">
// //                                                     <label className="form-label" htmlFor="address">Address</label>
// //                                                     <input id="address" name="address" className="form-control" placeholder="Flat / Tower / Street" required />
// //                                                 </div>
// //                                                 <div className="col-12">
// //                                                     <label className="form-label" htmlFor="mobile">Mobile Number</label>
// //                                                     <input
// //                                                         type="tel"
// //                                                         id="mobile"
// //                                                         name="mobile"
// //                                                         className="form-control"
// //                                                         placeholder="10-digit mobile number"
// //                                                         required
// //                                                         pattern="^[6-9]\d{9}$"     // or "^[0-9]{10}$"
// //                                                         inputMode="numeric"
// //                                                         autoComplete="tel-national"
// //                                                         aria-describedby="mobileHelp"
// //                                                     />
// //                                                     <small id="mobileHelp" className="text-muted">
// //                                                         Enter a 10-digit Indian number (starts with 6–9). No spaces or dashes.
// //                                                     </small>
// //                                                 </div>
// //                                                 <div className="col-12">
// //                                                     <label className="form-label" htmlFor="notes">Notes (optional)</label>
// //                                                     <textarea id="notes" name="notes" className="form-control" rows={3} placeholder="Any specifics? e.g., brand/model, problem details"></textarea>
// //                                                 </div>
// //                                             </div>

// //                                             <div className="mt-3 d-flex justify-content-end gap-2">
// //                                                 <button type="button" className="btn btn-outline-secondary" onClick={closeBooking} disabled={submitting}>
// //                                                     Cancel
// //                                                 </button>
// //                                                 <button type="submit" className="btn btn-primary" disabled={submitting}>
// //                                                     {submitting ? "Submitting…" : "Confirm Booking"}
// //                                                 </button>
// //                                             </div>
// //                                         </form>
// //                                     )}
// //                                 </div>
// //                             </div>
// //                         </div>
// //                     </div>
// //                 </div>
// //             </div>
// //         </section>
// //     );
// // };

// // export default CategoryServices;

// // src/pages/CategoryServices.jsx
// import React, { useEffect, useMemo, useState } from "react";
// import { useNavigate, useParams } from "react-router-dom";
// import {
//     subscribeCategories,
//     subscribeSubcategories,
//     subscribeServiceItems,
//     createBooking,
// } from "../lib/servicesApi";
// import "../styles/theme.css";
// import { auth } from "../firebase";

// /** Decode minimal HTML entities for display */
// const decodeEntities = (str) =>
//     String(str || "")
//         .replace(/&amp;/g, "&")
//         .replace(/&lt;/g, "<")
//         .replace(/&gt;/g, ">")
//         .replace(/&quot;/g, '"')
//         .replace(/&#039;/g, "'");

// /** Slugify used both in ServicesSection and here to resolve catSlug */
// const slugify = (s) =>
//     decodeEntities(String(s || ""))
//         .toLowerCase()
//         .trim()
//         .replace(/['"]/g, "")
//         .replace(/&/g, "and")
//         .replace(/[^a-z0-9]+/g, "-")
//         .replace(/^-+|-+$/g, "");

// const RESERVED_NAMES = new Set(["date", "time", "address", "mobile", "notes"]);

// const CategoryServices = () => {
//     const { catSlug } = useParams();
//     const navigate = useNavigate?.();

//     // Data state
//     const [cats, setCats] = useState([]);
//     const [catError, setCatError] = useState(null);
//     const [catsLoading, setCatsLoading] = useState(true);

//     const [subcats, setSubcats] = useState([]);
//     const [subcatError, setSubcatError] = useState(null);
//     const [subcatsLoading, setSubcatsLoading] = useState(true);

//     const [list, setList] = useState([]);
//     const [svcError, setSvcError] = useState(null);
//     const [svcLoading, setSvcLoading] = useState(true);

//     // Filters
//     const [activeSubcat, setActiveSubcat] = useState("all");

//     const [selected, setSelected] = useState(null);
//     const [submitting, setSubmitting] = useState(false);

//     const openBooking = (svc) => setSelected(svc);
//     const closeBooking = () => setSelected(null);

//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         if (!selected) return;

//         try {
//             if (!auth?.currentUser) {
//                 alert("Please sign in to book a service.");
//                 return;
//             }

//             setSubmitting(true);
//             const fd = new FormData(e.currentTarget);

//             // Universal fields
//             const date = fd.get("date") || null;
//             const time = fd.get("time") || null;
//             const address = (fd.get("address") || "").trim() || null;
//             const notes = (fd.get("notes") || "").trim() || null;

//             // Mobile: sanitize & validate
//             let mobileRaw = fd.get("mobile") || "";
//             const mobile = mobileRaw.replace(/\D/g, ""); // keep only digits
//             // India: 10 digits and starts with 6-9. If you don't want this constraint, use: /^[0-9]{10}$/
//             const isValidMobile = /^[6-9]\d{9}$/.test(mobile);
//             if (!isValidMobile) {
//                 alert("Please enter a valid 10-digit mobile number (starts with 6-9).");
//                 return; // finally will still reset submitting
//             }

//             console.log("[BOOKING] raw mobile from form:", fd.get("mobile"));

//             // Collect dynamic form fields (skip reserved names)
//             const formFields = Array.isArray(selected.formFields) ? selected.formFields : [];
//             const formData = {};
//             formFields.forEach((f) => {
//                 const name = f?.name;
//                 if (!name || RESERVED_NAMES.has(name)) return;

//                 if (f.type === "checkbox") {
//                     formData[name] = fd.get(name) ? true : false;
//                 } else {
//                     formData[name] = (fd.get(name) ?? "").toString().trim();
//                 }
//             });

//             const bookingPayload = { date, time, address, mobile, notes, formData };

//             // Debug (optional): verify mobile exists in payload
//             // console.log("bookingPayload:", bookingPayload);

//             await createBooking(selected, bookingPayload, { mirrorUnderServiceDoc: false });

//             closeBooking();
//             alert(`Booking submitted for "${selected.name ?? selected.title}". We’ll reach out soon!`);
//             console.log("[BOOKING] bookingPayload being sent:", bookingPayload);
//         } catch (err) {
//             console.error("Booking submit failed:", err);
//             const code = err?.code || "unknown";
//             const msg = err?.message || "Failed to submit booking.";
//             alert(`${msg}\n(${code})`);
//         } finally {
//             setSubmitting(false);
//         }
//     };

//     // Resolve selected category from slug
//     const resolved = useMemo(() => {
//         if (!cats?.length || !catSlug) return null;
//         const match = cats.find((c) => {
//             const s1 = slugify(c.label || c.key);
//             const s2 = slugify(c.key || c.label);
//             return s1 === catSlug || s2 === catSlug;
//         });
//         if (!match) return null;
//         return {
//             key: match.key,
//             label: decodeEntities(match.label || match.key),
//         };
//     }, [cats, catSlug]);

//     // Subscribe to categories
//     useEffect(() => {
//         setCatsLoading(true);
//         const unsub = subscribeCategories(
//             (items) => {
//                 setCats(items || []);
//                 setCatsLoading(false);
//             },
//             (err) => {
//                 setCatError(err);
//                 setCatsLoading(false);
//             }
//         );
//         return () => unsub && unsub();
//     }, []);

//     // Subscribe subcategories for this category
//     useEffect(() => {
//         if (!resolved?.key) {
//             setSubcats([]);
//             setSubcatsLoading(false);
//             return;
//         }
//         setSubcatsLoading(true);
//         const unsub = subscribeSubcategories(
//             (items) => {
//                 const filtered = (items || []).filter((s) => s.categoryKey === resolved.key);
//                 setSubcats(filtered);
//                 setSubcatsLoading(false);
//             },
//             (err) => {
//                 setSubcatError(err);
//                 setSubcatsLoading(false);
//             },
//             { categoryKey: resolved.key }
//         );
//         return () => unsub && unsub();
//     }, [resolved?.key]);

//     // Subscribe services with filters
//     useEffect(() => {
//         if (!resolved?.key) {
//             setList([]);
//             setSvcLoading(false);
//             return;
//         }
//         setSvcLoading(true);
//         const unsub = subscribeServiceItems(
//             (items) => {
//                 setList(items || []);
//                 setSvcLoading(false);
//             },
//             (err) => {
//                 setSvcError(err);
//                 setSvcLoading(false);
//             },
//             {
//                 category: resolved.key,
//                 subcategory: activeSubcat === "all" ? undefined : activeSubcat,
//             }
//         );
//         return () => unsub();
//     }, [resolved?.key, activeSubcat]);

//     // Subcategory chips
//     const subcatChips = useMemo(() => {
//         const chips = [{ key: "all", label: "All" }];
//         const active = (subcats || []).filter((s) => s.active);
//         active.forEach((s) => chips.push({ key: s.key, label: decodeEntities(s.label || s.key) }));
//         return chips;
//     }, [subcats]);

//     // Visible services
//     const services = useMemo(() => {
//         const activeOnly = (list || []).filter((s) => !!s.isActive);
//         return resolved?.key ? activeOnly.filter((s) => s.category === resolved.key) : activeOnly;
//     }, [list, resolved?.key]);

//     const goBack = () => {
//         try {
//             if (navigate) {
//                 navigate(-1);
//                 return;
//             }
//         } catch { }
//         if (window.history.length > 1) window.history.back();
//         else window.location.href = "/";
//     };

//     const titleText = resolved?.label || "Services";

//     /** Render a single dynamic field based on service.formFields definition */
//     const renderField = (f) => {
//         if (!f?.name || RESERVED_NAMES.has(f.name)) return null;
//         const id = `dyn_${f.name}`;
//         const required = !!f.required;
//         const label = f.label || f.name;

//         switch (f.type) {
//             case "text":
//             case "email":
//             case "tel":
//             case "number":
//                 return (
//                     <div className="col-12">
//                         <label className="form-label" htmlFor={id}>{label}</label>
//                         <input
//                             id={id}
//                             name={f.name}
//                             type={f.type}
//                             className="form-control"
//                             required={required}
//                             inputMode={f.type === "tel" ? "tel" : undefined}
//                         />
//                     </div>
//                 );
//             case "textarea":
//                 return (
//                     <div className="col-12">
//                         <label className="form-label" htmlFor={id}>{label}</label>
//                         <textarea id={id} name={f.name} className="form-control" rows={3} required={required} />
//                     </div>
//                 );
//             case "select":
//                 return (
//                     <div className="col-12">
//                         <label className="form-label" htmlFor={id}>{label}</label>
//                         <select id={id} name={f.name} className="form-select" required={required}>
//                             <option value="">Select…</option>
//                             {(f.options || []).map((opt) => (
//                                 <option key={String(opt)} value={opt}>{opt}</option>
//                             ))}
//                         </select>
//                     </div>
//                 );
//             case "radio":
//                 return (
//                     <div className="col-12">
//                         <div className="form-label">{label}</div>
//                         <div className="d-flex flex-wrap gap-3">
//                             {(f.options || []).map((opt, idx) => {
//                                 const oid = `${id}_${idx}`;
//                                 return (
//                                     <div className="form-check" key={oid}>
//                                         <input
//                                             className="form-check-input"
//                                             type="radio"
//                                             name={f.name}
//                                             id={oid}
//                                             value={opt}
//                                             required={required}
//                                         />
//                                         <label className="form-check-label" htmlFor={oid}>{opt}</label>
//                                     </div>
//                                 );
//                             })}
//                         </div>
//                     </div>
//                 );
//             case "checkbox":
//                 return (
//                     <div className="col-12">
//                         <div className="form-check">
//                             <input className="form-check-input" type="checkbox" id={id} name={f.name} />
//                             <label className="form-check-label" htmlFor={id}>{label}</label>
//                         </div>
//                     </div>
//                 );
//             default:
//                 return (
//                     <div className="col-12">
//                         <label className="form-label" htmlFor={id}>{label}</label>
//                         <input id={id} name={f.name} className="form-control" required={required} />
//                     </div>
//                 );
//         }
//     };

//     return (
//         <section className="py-5 bg-light">
//             <div className="container">
//                 {/* Sticky header with back */}
//                 <div
//                     className="d-flex align-items-center justify-content-between mb-3"
//                     style={{
//                         position: "sticky",
//                         top: 0,
//                         zIndex: 10,
//                         background: "var(--bs-light, #f8f9fa)",
//                         padding: "8px 0",
//                     }}
//                 >
//                     <button type="button" className="btn btn-outline-secondary" onClick={goBack}>
//                         <i className="bi bi-arrow-left me-1" aria-hidden="true"></i>
//                         Back
//                     </button>
//                     <span className="text-muted small">
//                         Viewing: <strong>{titleText}</strong>
//                     </span>
//                 </div>

//                 {/* Heading */}
//                 <header className="mb-4 text-center">
//                     <h2 className="fw-bold">{titleText}</h2>
//                     <p className="text-muted mb-2">Browse services and filter by subcategory.</p>
//                 </header>

//                 {/* Subcategory filter chips */}
//                 <div className="d-flex flex-wrap justify-content-center gap-2 mb-3">
//                     {subcatChips.map((chip) => (
//                         <button
//                             key={chip.key}
//                             type="button"
//                             className={`btn btn-sm ${activeSubcat === chip.key ? "btn-primary-navbar-reg" : "btn-outline-teal"}`}
//                             onClick={() => setActiveSubcat(chip.key)}
//                             aria-pressed={activeSubcat === chip.key}
//                         >
//                             {chip.label}
//                         </button>
//                     ))}
//                 </div>

//                 {/* Errors */}
//                 {catError && <div className="alert alert-danger">Categories error: {catError.message}</div>}
//                 {subcatError && <div className="alert alert-danger">Subcategories error: {subcatError.message}</div>}
//                 {svcError && <div className="alert alert-danger">Services error: {svcError.message}</div>}

//                 {/* Loading */}
//                 {(catsLoading || subcatsLoading || svcLoading) && (
//                     <div className="text-center my-4">
//                         <div className="spinner-border text-primary" role="status" aria-hidden="true" />
//                         <div className="mt-2 text-muted small">Loading…</div>
//                     </div>
//                 )}

//                 {/* Services grid */}
//                 <div className="row g-3">
//                     {services.map((svc) => {
//                         const title = svc.name ?? svc.title ?? "Untitled service";
//                         const desc = svc.description ?? svc.desc ?? "";
//                         const icon = svc.icon ?? "bi-tools";
//                         const price = typeof svc.price === "number" ? svc.price : Number(svc.price) || 0;

//                         return (
//                             <div key={svc.id} className="col-12 col-sm-6 col-lg-4">
//                                 <article className="card h-100 shadow-sm">
//                                     <div className="card-body d-flex flex-column">
//                                         <div className="d-flex align-items-center mb-2">
//                                             <span className="rounded-3 p-2 me-2" style={{ background: "#EEF2FF" }}>
//                                                 <i className={`bi ${icon} text-primary-label fs-5`} aria-hidden="true"></i>
//                                             </span>
//                                             <h5 className="card-title mb-0">{title}</h5>
//                                         </div>
//                                         <p className="text-muted mb-2 flex-grow-1">{desc}</p>
//                                         <div className="d-flex align-items-center justify-content-between">
//                                             <span className="text-secondary">Starting at ₹{price}</span>
//                                             <button
//                                                 type="button"
//                                                 className="btn btn-outline-teal btn-sm"
//                                                 onClick={() => openBooking({ ...svc, title, desc, icon, price })}
//                                                 aria-label={`Book ${title}`}
//                                             >
//                                                 Book Service
//                                             </button>
//                                         </div>
//                                     </div>
//                                 </article>
//                             </div>
//                         );
//                     })}

//                     {!svcLoading && services.length === 0 && !svcError && (
//                         <div className="col-12">
//                             <div className="alert alert-info">No services available for this subcategory yet.</div>
//                         </div>
//                     )}

//                     {/* Booking Modal (controlled) */}
//                     <div
//                         className={`modal fade ${selected ? "show d-block" : ""}`}
//                         tabIndex={-1}
//                         role="dialog"
//                         aria-modal={selected ? "true" : "false"}
//                         aria-hidden={selected ? "false" : "true"}
//                     >
//                         <div className="modal-dialog modal-dialog-centered">
//                             <div className="modal-content">
//                                 <div className="modal-header primary-bg ">
//                                     <h5 className="modal-title">
//                                         {selected ? `Book: ${selected.title}` : "Book Service"}
//                                     </h5>
//                                     <button
//                                         type="button"
//                                         className="btn-close"
//                                         aria-label="Close"
//                                         onClick={closeBooking}
//                                         disabled={submitting}
//                                     />
//                                 </div>
//                                 <div className="modal-body">
//                                     {selected && (
//                                         <form onSubmit={handleSubmit}>
//                                             <div className="mb-3 d-flex align-items-center">
//                                                 <span className="rounded-3 p-2 me-2" style={{ background: "#EEF2FF" }}>
//                                                     <i className={`bi ${selected.icon} text-primary-label fs-5`} aria-hidden="true"></i>
//                                                 </span>
//                                                 <div>
//                                                     <div className="fw-semibold">{selected.title}</div>
//                                                     <small className="text-muted">Starting at ₹{selected.price}</small>
//                                                 </div>
//                                             </div>

//                                             <div className="row g-3">
//                                                 {/* --- DYNAMIC SERVICE-SPECIFIC FIELDS --- */}
//                                                 {(Array.isArray(selected.formFields) ? selected.formFields : [])
//                                                     .filter((f) => f?.name && !RESERVED_NAMES.has(f.name))
//                                                     .map((f, idx) => (
//                                                         <React.Fragment key={`${f.name}_${idx}`}>
//                                                             {renderField(f)}
//                                                         </React.Fragment>
//                                                     ))}

//                                                 {/* --- UNIVERSAL SCHEDULING/ADDRESS FIELDS --- */}
//                                                 <div className="col-12 col-md-6">
//                                                     <label className="form-label" htmlFor="date">Date</label>
//                                                     <input type="date" id="date" name="date" className="form-control" required />
//                                                 </div>
//                                                 <div className="col-12 col-md-6">
//                                                     <label className="form-label" htmlFor="time">Time</label>
//                                                     <input type="time" id="time" name="time" className="form-control" required />
//                                                 </div>
//                                                 <div className="col-12">
//                                                     <label className="form-label" htmlFor="address">Address</label>
//                                                     <input id="address" name="address" className="form-control" placeholder="Flat / Tower / Street" required />
//                                                 </div>
//                                                 <div className="col-12">
//                                                     <label className="form-label" htmlFor="mobile">Mobile Number</label>
//                                                     <input
//                                                         type="tel"
//                                                         id="mobile"
//                                                         name="mobile"
//                                                         className="form-control"
//                                                         placeholder="10-digit mobile number"
//                                                         required
//                                                         pattern="^[6-9]\d{9}$"  // or "^[0-9]{10}$"
//                                                         inputMode="numeric"
//                                                         autoComplete="tel-national"
//                                                         aria-describedby="mobileHelp"
//                                                     />
//                                                     <small id="mobileHelp" className="text-muted">
//                                                         Enter a 10-digit Indian number (starts with 6–9). No spaces or dashes.
//                                                     </small>
//                                                 </div>
//                                                 <div className="col-12">
//                                                     <label className="form-label" htmlFor="notes">Notes (optional)</label>
//                                                     <textarea id="notes" name="notes" className="form-control" rows={3} placeholder="Any specifics? e.g., brand/model, problem details" />
//                                                 </div>
//                                             </div>

//                                             <div className="mt-3 d-flex justify-content-end gap-2">
//                                                 <button type="button" className="btn btn-outline-secondary" onClick={closeBooking} disabled={submitting}>
//                                                     Cancel
//                                                 </button>
//                                                 <button type="submit" className="btn btn-primary" disabled={submitting}>
//                                                     {submitting ? "Submitting…" : "Confirm Booking"}
//                                                 </button>
//                                             </div>
//                                         </form>
//                                     )}
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                     {/* End Modal */}
//                 </div>
//             </div>
//         </section>
//     );
// };

// export default CategoryServices;

// src/pages/CategoryServices.jsx
import React, { useEffect, useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
    subscribeCategories,
    subscribeSubcategories,
    subscribeServiceItems,
    createBooking,
} from "../lib/servicesApi";
import "../styles/theme.css";
import { auth, db } from "../firebase";
import { onAuthStateChanged, signInWithPopup, GoogleAuthProvider } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";

/** Decode minimal HTML entities for display */
const decodeEntities = (str) =>
    String(str || "")
        .replace(/&amp;/g, "&")
        .replace(/&lt;/g, "<")
        .replace(/&gt;/g, ">")
        .replace(/&quot;/g, '"')
        .replace(/&#039;/g, "'");

/** Slugify used both in ServicesSection and here to resolve catSlug */
const slugify = (s) =>
    decodeEntities(String(s || ""))
        .toLowerCase()
        .trim()
        .replace(/['"]/g, "")
        .replace(/&/g, "and")
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/^-+|-+$/g, "");

const RESERVED_NAMES = new Set(["date", "time", "address", "mobile", "notes"]);

const CategoryServices = () => {
    const { catSlug } = useParams();
    const navigate = useNavigate?.();

    // Data state
    const [cats, setCats] = useState([]);
    const [catError, setCatError] = useState(null);
    const [catsLoading, setCatsLoading] = useState(true);

    const [subcats, setSubcats] = useState([]);
    const [subcatError, setSubcatError] = useState(null);
    const [subcatsLoading, setSubcatsLoading] = useState(true);

    const [list, setList] = useState([]);
    const [svcError, setSvcError] = useState(null);
    const [svcLoading, setSvcLoading] = useState(true);

    // Filters
    const [activeSubcat, setActiveSubcat] = useState("all");

    // Booking state
    const [selected, setSelected] = useState(null);
    const [submitting, setSubmitting] = useState(false);

    // Auth / Profile state
    const [authReady, setAuthReady] = useState(false);
    const [profile, setProfile] = useState(null); // { name, mobile, address } or null
    const [bookingMode, setBookingMode] = useState("guest"); // 'guest' | 'signedIn'
    const [showAuthChoice, setShowAuthChoice] = useState(false);

    // --- Helpers ---
    const fetchUserProfile = async (uid) => {
        try {
            const ref = doc(db, "users", uid);
            const snap = await getDoc(ref);
            if (!snap.exists()) return null;
            const data = snap.data() || {};
            return {
                name: data.name || data.displayName || "",
                mobile: (data.mobile || data.phone || "").toString(),
                address: data.address || data.addressLine || "",
            };
        } catch (e) {
            console.error("fetchUserProfile failed:", e);
            return null;
        }
    };

    const profileHasContact = useMemo(() => {
        const m = (profile?.mobile || "").toString().replace(/\D/g, "");
        const a = (profile?.address || "").trim();
        // India-friendly rule: 10 digits starting with 6-9
        const okMobile = /^[6-9]\d{9}$/.test(m);
        return okMobile && a.length > 0;
    }, [profile]);

    // --- Auth state listener ---
    useEffect(() => {
        const unsub = onAuthStateChanged(auth, async (user) => {
            setAuthReady(true);
            if (user) {
                const p = await fetchUserProfile(user.uid);
                setProfile(p);
            } else {
                setProfile(null);
            }
        });
        return () => unsub && unsub();
    }, []);

    // --- Booking open flow ---
    const openBooking = async (svc) => {
        setSelected(svc);
        // If user is signed in, prefer signed-in mode (hide address & mobile if profile has them)
        const user = auth?.currentUser;
        if (user) {
            try {
                const p = profile || (await fetchUserProfile(user.uid));
                setProfile(p);
            } catch { }
            setBookingMode("signedIn");
            setShowAuthChoice(false);
        } else {
            // Not signed in → ask user to sign in or continue as guest
            setBookingMode("guest");
            setShowAuthChoice(true);
        }
    };

    const closeBooking = () => {
        setSelected(null);
        setShowAuthChoice(false);
    };

    const handleSignInAndContinue = async () => {
        try {
            const provider = new GoogleAuthProvider();
            await signInWithPopup(auth, provider);
            const user = auth.currentUser;
            const p = user ? await fetchUserProfile(user.uid) : null;
            setProfile(p);
            setBookingMode("signedIn");
            setShowAuthChoice(false);
        } catch (e) {
            console.error("Sign-in failed:", e);
            alert("Sign-in failed. You can continue as guest or try again.");
        }
    };

    const handleContinueAsGuest = () => {
        setBookingMode("guest");
        setShowAuthChoice(false);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!selected) return;

        try {
            setSubmitting(true);
            const fd = new FormData(e.currentTarget);

            // Universal fields
            const date = fd.get("date") || null;
            const time = fd.get("time") || null;
            const notes = (fd.get("notes") || "").trim() || null;

            let address = null;
            let mobile = null;

            if (bookingMode === "signedIn" && profileHasContact) {
                // Use profile values and hide inputs
                address = (profile?.address || "").trim();
                mobile = (profile?.mobile || "").toString().replace(/\D/g, "");
            } else {
                // Use form inputs (guest OR signed-in without complete profile)
                address = (fd.get("address") || "").trim() || null;

                const mobileRaw = fd.get("mobile") || "";
                mobile = mobileRaw.toString().replace(/\D/g, "");
                const isValidMobile = /^[6-9]\d{9}$/.test(mobile);
                if (!isValidMobile) {
                    alert("Please enter a valid 10-digit mobile number (starts with 6-9).");
                    return;
                }
            }

            if (!address) {
                alert("Please enter a valid address.");
                return;
            }

            // Collect dynamic fields (skip reserved)
            const formFields = Array.isArray(selected.formFields) ? selected.formFields : [];
            const formData = {};
            formFields.forEach((f) => {
                const name = f?.name;
                if (!name || RESERVED_NAMES.has(name)) return;
                if (f.type === "checkbox") {
                    formData[name] = fd.get(name) ? true : false;
                } else {
                    formData[name] = (fd.get(name) ?? "").toString().trim();
                }
            });

            const bookingPayload = { date, time, address, mobile, notes, formData };

            // Debug (optional)
            // console.log("[BOOKING] payload:", bookingPayload);

            await createBooking(selected, bookingPayload, { mirrorUnderServiceDoc: false });

            closeBooking();
            alert(`Booking submitted for "${selected.name ?? selected.title}". We’ll reach out soon!`);
        } catch (err) {
            console.error("Booking submit failed:", err);
            const code = err?.code || "unknown";
            const msg = err?.message || "Failed to submit booking.";
            alert(`${msg}\n(${code})`);
        } finally {
            setSubmitting(false);
        }
    };

    // Resolve selected category from slug
    const resolved = useMemo(() => {
        if (!cats?.length || !catSlug) return null;
        const match = cats.find((c) => {
            const s1 = slugify(c.label || c.key);
            const s2 = slugify(c.key || c.label);
            return s1 === catSlug || s2 === catSlug;
        });
        if (!match) return null;
        return {
            key: match.key,
            label: decodeEntities(match.label || match.key),
        };
    }, [cats, catSlug]);

    // Subscribe to categories
    useEffect(() => {
        setCatsLoading(true);
        const unsub = subscribeCategories(
            (items) => {
                setCats(items || []);
                setCatsLoading(false);
            },
            (err) => {
                setCatError(err);
                setCatsLoading(false);
            }
        );
        return () => unsub && unsub();
    }, []);

    // Subscribe subcategories for this category
    useEffect(() => {
        if (!resolved?.key) {
            setSubcats([]);
            setSubcatsLoading(false);
            return;
        }
        setSubcatsLoading(true);
        const unsub = subscribeSubcategories(
            (items) => {
                const filtered = (items || []).filter((s) => s.categoryKey === resolved.key);
                setSubcats(filtered);
                setSubcatsLoading(false);
            },
            (err) => {
                setSubcatError(err);
                setSubcatsLoading(false);
            },
            { categoryKey: resolved.key }
        );
        return () => unsub && unsub();
    }, [resolved?.key]);

    // Subscribe services with filters
    useEffect(() => {
        if (!resolved?.key) {
            setList([]);
            setSvcLoading(false);
            return;
        }
        setSvcLoading(true);
        const unsub = subscribeServiceItems(
            (items) => {
                setList(items || []);
                setSvcLoading(false);
            },
            (err) => {
                setSvcError(err);
                setSvcLoading(false);
            },
            {
                category: resolved.key,
                subcategory: activeSubcat === "all" ? undefined : activeSubcat,
            }
        );
        return () => unsub();
    }, [resolved?.key, activeSubcat]);

    // Build subcategory chips
    const subcatChips = useMemo(() => {
        const chips = [{ key: "all", label: "All" }];
        const active = (subcats || []).filter((s) => s.active);
        active.forEach((s) => chips.push({ key: s.key, label: decodeEntities(s.label || s.key) }));
        return chips;
    }, [subcats]);

    // Visible services
    const services = useMemo(() => {
        const activeOnly = (list || []).filter((s) => !!s.isActive);
        return resolved?.key ? activeOnly.filter((s) => s.category === resolved.key) : activeOnly;
    }, [list, resolved?.key]);

    const goBack = () => {
        try {
            if (navigate) {
                navigate(-1);
                return;
            }
        } catch { }
        if (window.history.length > 1) window.history.back();
        else window.location.href = "/";
    };

    const titleText = resolved?.label || "Services";

    /** Render a single dynamic field based on service.formFields definition */
    const renderField = (f) => {
        if (!f?.name || RESERVED_NAMES.has(f.name)) return null;
        const id = `dyn_${f.name}`;
        const required = !!f.required;
        const label = f.label || f.name;

        switch (f.type) {
            case "text":
            case "email":
            case "tel":
            case "number":
                return (
                    <div className="col-12">
                        <label className="form-label" htmlFor={id}>{label}</label>
                        <input
                            id={id}
                            name={f.name}
                            type={f.type}
                            className="form-control"
                            required={required}
                            inputMode={f.type === "tel" ? "tel" : undefined}
                        />
                    </div>
                );
            case "textarea":
                return (
                    <div className="col-12">
                        <label className="form-label" htmlFor={id}>{label}</label>
                        <textarea id={id} name={f.name} className="form-control" rows={3} required={required} />
                    </div>
                );
            case "select":
                return (
                    <div className="col-12">
                        <label className="form-label" htmlFor={id}>{label}</label>
                        <select id={id} name={f.name} className="form-select" required={required}>
                            <option value="">Select…</option>
                            {(f.options || []).map((opt) => (
                                <option key={String(opt)} value={opt}>{opt}</option>
                            ))}
                        </select>
                    </div>
                );
            case "radio":
                return (
                    <div className="col-12">
                        <div className="form-label">{label}</div>
                        <div className="d-flex flex-wrap gap-3">
                            {(f.options || []).map((opt, idx) => {
                                const oid = `${id}_${idx}`;
                                return (
                                    <div className="form-check" key={oid}>
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                            name={f.name}
                                            id={oid}
                                            value={opt}
                                            required={required}
                                        />
                                        <label className="form-check-label" htmlFor={oid}>{opt}</label>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                );
            case "checkbox":
                return (
                    <div className="col-12">
                        <div className="form-check">
                            <input className="form-check-input" type="checkbox" id={id} name={f.name} />
                            <label className="form-check-label" htmlFor={id}>{label}</label>
                        </div>
                    </div>
                );
            default:
                return (
                    <div className="col-12">
                        <label className="form-label" htmlFor={id}>{label}</label>
                        <input id={id} name={f.name} className="form-control" required={required} />
                    </div>
                );
        }
    };

    return (
        <section className="py-5 bg-light">
            <div className="container">
                {/* Sticky header with back */}
                <div
                    className="d-flex align-items-center justify-content-between mb-3"
                    style={{
                        position: "sticky",
                        top: 0,
                        zIndex: 10,
                        background: "var(--bs-light, #f8f9fa)",
                        padding: "8px 0",
                    }}
                >
                    <button type="button" className="btn btn-outline-secondary" onClick={goBack}>
                        <i className="bi bi-arrow-left me-1" aria-hidden="true"></i>
                        Back
                    </button>
                    <span className="text-muted small">
                        Viewing: <strong>{titleText}</strong>
                    </span>
                </div>

                {/* Heading */}
                <header className="mb-4 text-center">
                    <h2 className="fw-bold">{titleText}</h2>
                    <p className="text-muted mb-2">Browse services and filter by subcategory.</p>
                </header>

                {/* Subcategory filter chips */}
                <div className="d-flex flex-wrap justify-content-center gap-2 mb-3">
                    {subcatChips.map((chip) => (
                        <button
                            key={chip.key}
                            type="button"
                            className={`btn btn-sm ${activeSubcat === chip.key ? "btn-primary-navbar-reg" : "btn-outline-teal"}`}
                            onClick={() => setActiveSubcat(chip.key)}
                            aria-pressed={activeSubcat === chip.key}
                        >
                            {chip.label}
                        </button>
                    ))}
                </div>

                {/* Errors */}
                {catError && <div className="alert alert-danger">Categories error: {catError.message}</div>}
                {subcatError && <div className="alert alert-danger">Subcategories error: {subcatError.message}</div>}
                {svcError && <div className="alert alert-danger">Services error: {svcError.message}</div>}

                {/* Loading */}
                {(catsLoading || subcatsLoading || svcLoading) && (
                    <div className="text-center my-4">
                        <div className="spinner-border text-primary" role="status" aria-hidden="true" />
                        <div className="mt-2 text-muted small">Loading…</div>
                    </div>
                )}

                {/* Services grid */}
                <div className="row g-3">
                    {services.map((svc) => {
                        const title = svc.name ?? svc.title ?? "Untitled service";
                        const desc = svc.description ?? svc.desc ?? "";
                        const icon = svc.icon ?? "bi-tools";
                        const price = typeof svc.price === "number" ? svc.price : Number(svc.price) || 0;

                        return (
                            <div key={svc.id} className="col-12 col-sm-6 col-lg-4">
                                <article className="card h-100 shadow-sm">
                                    <div className="card-body d-flex flex-column">
                                        <div className="d-flex align-items-center mb-2">
                                            <span className="rounded-3 p-2 me-2" style={{ background: "#EEF2FF" }}>
                                                <i className={`bi ${icon} text-primary-label fs-5`} aria-hidden="true"></i>
                                            </span>
                                            <h5 className="card-title mb-0">{title}</h5>
                                        </div>
                                        <p className="text-muted mb-2 flex-grow-1">{desc}</p>
                                        <div className="d-flex align-items-center justify-content-between">
                                            <span className="text-secondary">Starting at ₹{price}</span>
                                            <button
                                                type="button"
                                                className="btn btn-outline-teal btn-sm"
                                                onClick={() => openBooking({ ...svc, title, desc, icon, price })}
                                                aria-label={`Book ${title}`}
                                            >
                                                Book Service
                                            </button>
                                        </div>
                                    </div>
                                </article>
                            </div>
                        );
                    })}

                    {!svcLoading && services.length === 0 && !svcError && (
                        <div className="col-12">
                            <div className="alert alert-info">No services available for this subcategory yet.</div>
                        </div>
                    )}

                    {/* ---------------- AUTH CHOICE MODAL ---------------- */}
                    <div
                        className={`modal fade ${showAuthChoice && selected ? "show d-block" : ""}`}
                        tabIndex={-1}
                        role="dialog"
                        aria-modal={showAuthChoice ? "true" : "false"}
                        aria-hidden={showAuthChoice ? "false" : "true"}
                    >
                        <div className="modal-dialog modal-dialog-centered">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">Sign in to book faster</h5>
                                    <button
                                        type="button"
                                        className="btn-close"
                                        aria-label="Close"
                                        onClick={closeBooking}
                                        disabled={submitting}
                                    />
                                </div>
                                <div className="modal-body">
                                    <p className="mb-3">
                                        Sign in to auto-fill your contact details (address & mobile), or continue as guest.
                                    </p>
                                    <div className="d-flex flex-column gap-2">
                                        <button
                                            type="button"
                                            className="btn btn-primary"
                                            onClick={handleSignInAndContinue}
                                        >
                                            <i className="bi bi-google me-1" aria-hidden="true"></i>
                                            Sign in & continue
                                        </button>
                                        <button
                                            type="button"
                                            className="btn btn-outline-secondary"
                                            onClick={handleContinueAsGuest}
                                        >
                                            Continue as guest
                                        </button>
                                    </div>
                                    <small className="text-muted d-block mt-2">
                                        {/* If your app has a dedicated login route, you can navigate instead of popup:
                       navigate('/login?returnTo=service-booking'); */}
                                    </small>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* ---------------- BOOKING MODAL ---------------- */}
                    <div
                        className={`modal fade ${selected && !showAuthChoice ? "show d-block" : ""}`}
                        tabIndex={-1}
                        role="dialog"
                        aria-modal={selected && !showAuthChoice ? "true" : "false"}
                        aria-hidden={selected && !showAuthChoice ? "false" : "true"}
                    >
                        <div className="modal-dialog modal-dialog-centered">
                            <div className="modal-content">
                                <div className="modal-header primary-bg ">
                                    <h5 className="modal-title">
                                        {selected ? `Book: ${selected.title}` : "Book Service"}
                                    </h5>
                                    <button
                                        type="button"
                                        className="btn-close"
                                        aria-label="Close"
                                        onClick={closeBooking}
                                        disabled={submitting}
                                    />
                                </div>
                                <div className="modal-body">
                                    {selected && (
                                        <>
                                            {/* If signed in and profile usable, show info strip */}
                                            {bookingMode === "signedIn" && profileHasContact && (
                                                <div className="alert alert-info d-flex flex-column" role="status">
                                                    <div className="fw-semibold mb-1">Using your profile contact details</div>
                                                    <div><strong>Mobile:</strong> {profile?.mobile}</div>
                                                    <div><strong>Address:</strong> {profile?.address}</div>
                                                </div>
                                            )}

                                            <form onSubmit={handleSubmit}>
                                                <div className="mb-3 d-flex align-items-center">
                                                    <span className="rounded-3 p-2 me-2" style={{ background: "#EEF2FF" }}>
                                                        <i className={`bi ${selected.icon} text-primary-label fs-5`} aria-hidden="true"></i>
                                                    </span>
                                                    <div>
                                                        <div className="fw-semibold">{selected.title}</div>
                                                        <small className="text-muted">Starting at ₹{selected.price}</small>
                                                    </div>
                                                </div>

                                                <div className="row g-3">
                                                    {/* --- DYNAMIC SERVICE-SPECIFIC FIELDS --- */}
                                                    {(Array.isArray(selected.formFields) ? selected.formFields : [])
                                                        .filter((f) => f?.name && !RESERVED_NAMES.has(f.name))
                                                        .map((f, idx) => (
                                                            <React.Fragment key={`${f.name}_${idx}`}>
                                                                {renderField(f)}
                                                            </React.Fragment>
                                                        ))}

                                                    {/* --- UNIVERSAL SCHEDULING/ADDRESS FIELDS --- */}
                                                    <div className="col-12 col-md-6">
                                                        <label className="form-label" htmlFor="date">Date</label>
                                                        <input type="date" id="date" name="date" className="form-control" required />
                                                    </div>
                                                    <div className="col-12 col-md-6">
                                                        <label className="form-label" htmlFor="time">Time</label>
                                                        <input type="time" id="time" name="time" className="form-control" required />
                                                    </div>

                                                    {/* Address & Mobile: show inputs only if guest OR profile missing */}
                                                    {!(bookingMode === "signedIn" && profileHasContact) && (
                                                        <>
                                                            <div className="col-12">
                                                                <label className="form-label" htmlFor="address">Address</label>
                                                                <input
                                                                    id="address"
                                                                    name="address"
                                                                    className="form-control"
                                                                    placeholder="Flat / Tower / Street"
                                                                    required
                                                                    defaultValue={profile?.address || ""}
                                                                />
                                                            </div>
                                                            <div className="col-12">
                                                                <label className="form-label" htmlFor="mobile">Mobile Number</label>
                                                                <input
                                                                    type="tel"
                                                                    id="mobile"
                                                                    name="mobile"
                                                                    className="form-control"
                                                                    placeholder="10-digit mobile number"
                                                                    required
                                                                    pattern="^[6-9]\d{9}$"
                                                                    inputMode="numeric"
                                                                    autoComplete="tel-national"
                                                                    aria-describedby="mobileHelp"
                                                                    defaultValue={(profile?.mobile || "").toString().replace(/\D/g, "")}
                                                                />
                                                                <small id="mobileHelp" className="text-muted">
                                                                    Enter a 10-digit Indian number (starts with 6–9). No spaces or dashes.
                                                                </small>
                                                            </div>
                                                        </>
                                                    )}

                                                    <div className="col-12">
                                                        <label className="form-label" htmlFor="notes">Notes (optional)</label>
                                                        <textarea
                                                            id="notes"
                                                            name="notes"
                                                            className="form-control"
                                                            rows={3}
                                                            placeholder="Any specifics? e.g., brand/model, problem details"
                                                        />
                                                    </div>
                                                </div>

                                                <div className="mt-3 d-flex justify-content-end gap-2">
                                                    <button
                                                        type="button"
                                                        className="btn btn-outline-secondary"
                                                        onClick={closeBooking}
                                                        disabled={submitting}
                                                    >
                                                        Cancel
                                                    </button>
                                                    <button type="submit" className="btn btn-primary" disabled={submitting}>
                                                        {submitting ? "Submitting…" : "Confirm Booking"}
                                                    </button>
                                                </div>
                                            </form>
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* ---------------- END BOOKING MODAL ---------------- */}
                </div>
            </div>
        </section>
    );
};

export default CategoryServices;